import React from "react";
import art from "../assets/studentlife/Art-and-Craft-Activities.webp";
import sports from "../assets/studentlife/Games.webp"
import community from "../assets/studentlife/awareness.webp";
import clubs from "../assets/studentlife/Drawing-Technique-Activities.webp";
import tech from "../assets/studentlife/Robotics.webp";
import leadership from "../assets/leadership.webp";
import dance from "../assets/cultural.webp";
import science from "../assets/science.webp";
import vedicmaths from "../assets/vedicmaths.webp";
import vedic from "../assets/studentlife/Vedic-maths-Classes.webp";

import abacus from "../assets/studentlife/vedic-maths-Sessions.webp";
import ImageSliderGrades from "./imagesslide";
import { FaPhoneAlt } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import CommonImageSlider from "./comandata";
import { studentLifeImages } from "./data";


import SeoMeta from "./seometa";
import { CommonAboutHeader } from "./CommonAboutHeader";
const title="School Life That Inspires"
 const description="At Rankridge Schools, students are at the heart of every decision we make. We believe each child is unique, with their own talents and dreams, and our role is to provide the right environment for them to grow with confidence. From the early years to Grade 12, students experience learning that goes beyond books, with opportunities in arts, sports, science, technology, and leadership.As they progress, we guide them with care, balancing academic strength with creativity, teamwork, and values. From middle school, students also receive early support for competitive readiness in a way that feels natural and stress-free. Every classroom is designed to encourage participation, curiosity, and problem-solving.At Rankridge, being a student means more than studying . it means discovering yourself, building friendships, and preparing for life."



const seopages = {
    title: "Rankridge Student Life | Skills, Activities & Growth",
    description:
      " Discover vibrant student life at Rankridge Schools Hyderabad — academics, sports, arts, and leadership skills",
    keywords: " rankridge student life, rankridge extracurricular activities, rankridge co-curricular activities, sports in rankridge school, arts in rankridge school, rankridge cultural events, student growth programs hyderabad, leadership skills for students, best school activities hyderabad, rankridge clubs and societies, personality development rankridge, rankridge school competitions, rankridge school talent shows, student achievements rankridge, vibrant student life hyderabad, rankridge life skills, student engagement rankridge, rankridge school festivals, best school environment hyderabad, student participation rankridge",
    canonical_path: "https://rankridgeschools.com/student-life/",
    og_description: "",
    og_image: "",
  };
export default function StudentLife() {

  const navigate=useNavigate();

   const closeMenu = () =>{
navigate("/form")
    window.scrollTo({top:0,behavior:"smooth"})
   } 
  const cards = [{
      title: "Vedic Maths",
      description:
        "Students participate in visual arts, music, and drama clubs to foster creativity and confidence.",
      image: vedic,
    },{
      title: "Abacus Maths",
      description:
        "Students participate in visual arts, music, and drama clubs to foster creativity and confidence.",
      image: abacus,
    },
    {
      title: "Creative Arts",
      description:
        "Students participate in visual arts, music, and drama clubs to foster creativity and confidence.",
      image: art,
    },
    {
      title: "Sports & Fitness",
      description:
        "Regular physical activities and sports competitions are encouraged for holistic development.",
      image: sports,
    },
    {
      title: "Community Service",
      description:
        "We instill a sense of social responsibility through volunteering and eco drives.",
      image: community,
    },
    {
      title: "Clubs & Activities",
      description:
        "Wide range of clubs including science, literature, robotics, and more for every interest.",
      image: clubs,
    },
    {
      title: "Technology Club",
      description:
        "Students explore new-age technology and build real-world problem-solving skills.",
      image: tech,
    },
    // {
    //   title: "Leadership Programs",
    //   description:
    //     "Workshops and student councils nurture future leaders with empathy and responsibility.",
    //   image: leadership,
    // },
    {
      title: "Dance & Culture",
      description:
        "Celebrate diversity through cultural fests, folk dances, and international days.",
      image: dance,
    },
    {
      title: "Science Exploration",
      description:
        "Hands-on experiments, science fairs, and space workshops spark curiosity.",
      image: science,
    },
  ];

  return (<div > 
    <h1 className="text-2xl text-center font-bold bg-white ">Empowering Students for Success at Rankridge Schools</h1>                         
    <h6  className="bg-white text-xl text-center text-black font-extrabold pb-6 ">Life Beyond Books: Learn, Create &  Inspire at Rankridge. 
 </h6>   
       <div className="me-2 ms-2">
      {/* <CommonImageSlider images={studentLifeImages}  /> */}
      <CommonAboutHeader  images={studentLifeImages} title={title} des={description}/>
      
     </div>
      
       <div className="flex flex-col sm:flex-row gap-4 justify-center md:justify-center p-1 pt-8 pb-4 bg-white">
              <a href="tel:+919959303873" className="flex items-center justify-center">
       <button className="flex font-roboto items-center justify-center gap-2 bg-[#20b2aa] text-black px-6 py-3 rounded-lg font-semibold hover:bg-gray-200 transition">
         <FaPhoneAlt />
         Call Now +91 99 59 303 873
       </button>
     </a>
     
               <button onClick={closeMenu} className="bg-green-900 text-white px-6 py-3 rounded-lg font-semibold hover:bg-green-800 transition">
               ENQUIRE NOW
               </button>
              
             </div>

    <section className="bg-[#20b2aa] text-white py-0 px-4 md:px-20 pt-4 pb-8">


      <div className="text-center mt-4 mb-12">
        <h2 className="text-3xl text-black md:text-5xl font-bold mb-4">
          {/* Student Life at Rankridge */}
          Growing, Exploring &  Leading at Rankridge
        </h2>
        <p className="text-lg   md:text-xl  max-w-3xl mx-auto">
          We believe learning happens everywhere. Our vibrant student life includes extracurriculars, sports, and leadership opportunities that empower every learner.
        </p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 w-full">
        {cards.map((card, index) => (
          <div
            key={index}
            className="bg-white text-green-900 rounded-xl overflow-hidden shadow-lg"
          >
            <img
              src={card.image}
              alt={card.title}
              className="w-full h-auto object-cover"
            />
            <div className="p-4">
              <h3 className="text-xl font-bold mb-2">{card.title}</h3>
              <p className="text-sm text-gray-700">{card.description}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
     <SeoMeta seopages={seopages} />
    
    </div>
  );
}
